import moment from "moment";
import React, { Component } from "react";
import { Nav, NavItem } from "react-bootstrap";
import { Route, Switch } from "react-router";
import { Link } from "react-router-dom";
import AuthContext from "../auth-context";
import ConfirmationDashboardService from "../utils/ConfirmationDashboardService";
import ConfirmationDashboardList from "./ConfirmationDashboardList";
import "./confirmation_dashboard.css";

class ConfirmationDashboardListView extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    const filter = {
      view: props.view,
      begin: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY"),
      end: moment()
        .subtract(1, "day")
        .format("DD MMM YYYY")
    };

    super(props, context);
    const { view } = props.match.params;
    this.state = {
      stats: {},
      activeView: view,
      filter: filter
    };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchStats(this.state.filter);
  }

  fetchStats(filter) {
    const finalFilter = filter || this.state.filter;

    ConfirmationDashboardService.stats(finalFilter).then(data => {
      this.setState({ stats: data });
    });
  }

  handleSelect = eventKey => {
    this.setState({ activeView: eventKey });
  };

  renderTimeWindowStat = (label, value) => (
    <div className="time-window-stat">
      <span className="time-window-label">{label}:</span>
      <span className="time-window-value">{value || 0}</span>
    </div>
  );

  renderTimeWindow = (title, data) => (
    <div className="col-md-6">
      <div className="time-window-card">
        <h5 className="time-window-title">{title}</h5>
        <div className="time-window-stats">
          {this.renderTimeWindowStat("Inbound Calls", data.inbound_calls_count)}
          {this.renderTimeWindowStat("Inbound Answer Rate", `${data.inbound_answer_rate}%`)}
          {this.renderTimeWindowStat("Outbound Answer Rate", `${data.outbound_answer_rate}%`)}
        </div>
      </div>
    </div>
  );

  render() {
    const { stats } = this.state;

    const cards = [
      {
        title: "Confirmation Rate",
        value: `${Math.round(stats.confirmed_percentage || 0)}%`
      },
      {
        title: "Presentation Rate",
        value: `${Math.round(stats.presented_percentage || 0)}%`
      },
      {
        title: "Confirmed but No Presentation",
        value: stats.tcs_confirmed_not_presented || 0
      },
      {
        title: "Spoke but Not Confirmed",
        value: stats.spoke_but_not_confirmed || 0
      },
      {
        title: "Unconfirmed with < 4 Calls",
        value: stats.unconfirmed_with_less_than_four_calls || 0
      },
      {
        title: "Unconfirmed",
        value: stats.unconfirmed || 0
      }
    ];

    const callMetricsCards = [
      {
        title: "Inbound Calls",
        value: stats.inbound_calls_count || 0
      },
      {
        title: "Inbound Answer Rate",
        value: `${stats.inbound_answer_rate || 0}%`
      },
      {
        title: "Outbound Answer Rate",
        value: `${stats.outbound_answer_rate || 0}%`
      }
    ];

    return (
      <div>
        <h3 className="first-title mb-4">Confirmation Effectiveness</h3>

        {/* === Stats cards section === */}
        <div className="stats-cards">
          {cards.map((c, i) => (
            <div key={i} className="stats-card">
              <div className="stats-card-header">
                <span className="stats-card-title">{c.title}</span>
              </div>
              <div className="stats-card-value">{c.value}</div>
            </div>
          ))}
        </div>

        {/* === Call Metrics section === */}
        <h3 className="first-title mb-4">Call Metrics</h3>
        <div className="stats-cards">
          {callMetricsCards.map((c, i) => (
            <div key={i} className="stats-card">
              <div className="stats-card-header">
                <span className="stats-card-title">{c.title}</span>
              </div>
              <div className="stats-card-value">{c.value}</div>
            </div>
          ))}
        </div>

        {/* === Time Window Breakdown === */}
        {stats.window_12_3pm && stats.window_6_8pm && (
          <div className="mt-4">
            <h3 className="first-title mb-4">Time Window Breakdown</h3>
            <div className="row">
              {this.renderTimeWindow("12pm - 3pm Window", stats.window_12_3pm)}
              {this.renderTimeWindow("6pm - 8pm Window", stats.window_6_8pm)}
            </div>
          </div>
        )}

        {/* === Tabs section === */}
        <div className="col-sm-12 mt-4">
          <Nav
            bsStyle="tabs"
            activeKey={this.state.activeView}
            onSelect={this.handleSelect.bind(this)}
          >
            <NavItem
              eventKey="tcs_confirmed_not_presented"
              componentClass={Link}
              to="/m1/confirmation_dashboard/list/tcs_confirmed_not_presented"
              href="/m1/confirmation_dashboard/list/tcs_confirmed_not_presented"
            >
              Confirmed but did not present
            </NavItem>
            <NavItem
              eventKey="spoke_but_not_confirmed"
              componentClass={Link}
              to="/m1/confirmation_dashboard/list/spoke_but_not_confirmed"
              href="/m1/confirmation_dashboard/list/spoke_but_not_confirmed"
            >
              Spoke but not confirmed
            </NavItem>
            <NavItem
              eventKey="unconfirmed_with_less_than_four_calls"
              componentClass={Link}
              to="/m1/confirmation_dashboard/list/unconfirmed_with_less_than_four_calls"
              href="/m1/confirmation_dashboard/list/unconfirmed_with_less_than_four_calls"
            >
              Unconfirmed &lt; 4 calls
            </NavItem>
            <NavItem
              eventKey="tcs_not_confirmed"
              componentClass={Link}
              to="/m1/confirmation_dashboard/list/tcs_not_confirmed"
              href="/m1/confirmation_dashboard/list/tcs_not_confirmed"
            >
              Unconfirmed
            </NavItem>
          </Nav>

          <div className="tab-content mt-1">
            <Switch>
              <Route
                view={this.state.activeView}
                render={props => (
                  <ConfirmationDashboardList
                    view={props.match.params.view}
                    onFilterChange={filter => this.fetchStats(filter)}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmationDashboardListView;
